import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'
import store from '@/store'

export default {
  resetTranslations({ commit }) {
    commit(types.RESET_TRANSLATIONS)
  },
  setCriteriaChanged({ commit }, value) {
    commit(types.SET_CRITERIA_CHANGED, value)
  },
  async setStep({ commit, state, dispatch }, value) {
    if (value !== 99) {
      commit(types.SET_STEP, value)
      commit(types.SET_VISITED_STEP, value)
    }
    if (state.criteriaChanged) {
      // if anything was changed, save the Scan Pro Criteria
      let profile = store.getters['auth/profile']
      let data = {
        businessId: profile.location.Id,
        criteria: state.scanProCriteria,
        checklist: state.scanProChecklist
      }
      await startLoading(dispatch, 'saveScanProConfiguration', () => http.post('scanpro/SaveScanProConfiguration', data))
      commit(types.SET_CRITERIA_CHANGED, false)
    }
  },
  resetVisitedStep({ commit }, value) {
    commit(types.RESET_VISITED_STEP, value)
  },
  async getRecommendations({ commit, dispatch }, firm) {
    const r = await startLoading(dispatch, 'getRecommendations', () => http.get(`testdrive/testdriveRecommendations?firm=${firm}`))
    commit(types.SET_RECOMMENDATIONS, r.data)
    return r.data
  },
  async getRecommendation({ commit, dispatch }, testDriveRecommendation) {
    const r = await startLoading(dispatch, 'getRecommendation', () => http.get(`testdrive/testdriveRecommendation?testDriveRecommendation=${testDriveRecommendation}`))
    commit(types.SET_RECOMMENDATION, r.data)
    return r.data
  },
  async saveRecommendation({ dispatch, state }) {
    const r = await startLoading(dispatch, 'saveRecommendation', () =>
      http.post('testdrive/saveTestDriveRecommendation', {
        firm: state.recommendation.firm,
        testDriveRecommendation: state.recommendation.testDriveRecommendation,
        recommendation: state.recommendation.recommendation,
        driveType: state.recommendation.driveType,
        vehicleMake: state.recommendation.vehicleMake,
        recommendationText: state.recommendation.recommendationText
      })
    )
    return r.data
  },
  async deleteRecommendation({ dispatch }, testDriveRecommendation) {
    const r = await startLoading(dispatch, 'deleteRecommendation', () => http.get(`testdrive/deleteTestdriveRecommendation?testDriveRecommendation=${testDriveRecommendation}`))
    return r.data
  },
  async saveNewTranslation({ dispatch }, data) {
    const r = await startLoading(dispatch, 'saveNewTranslation', () => http.post('language/addTranslation', data))
    return r.data
  },
  async saveTranslation({ dispatch }, data) {
    const r = await startLoading(dispatch, 'saveTranslation', () => http.post('language/saveTranslation', data))
    return r.data
  },
  async getTranslations({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getTranslations', () => http.get(`language/translations?translationType=${data.translationType}&languageCode=${data.languageCode}`))
    commit(types.SET_TRANSLATIONS, r.data)
    return r.data
  },
  async deleteTranslation({ dispatch }, translation) {
    const r = await startLoading(dispatch, 'deleteTranslation', () => http.get(`language/deleteTranslation?translation=${translation}`))
    return r.data
  },
  resetTestDriveResultType({ commit }) {
    commit(types.RESET_RESULTTYPE)
  },
  updateTestDriveResultType({ commit }, data) {
    commit(types.UPDATE_RESULTTYPE, data)
  },
  async getTestDriveResultTypes({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getTestDriveResultTypes', () =>
      http.get('lookup/testdriveResultType', {
        params: options
      })
    )
    commit(types.SET_RESULTTYPES, r.data)
    return r.data
  },
  async getTestDriveResultType({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getTestDriveResultType', () => http.get(`lookup/testdriveResultType?testdriveResultType=${id}`))
    commit(types.SET_RESULTTYPE, r.data)
    return r.data
  },
  async saveTestDriveResultType({ state, dispatch }) {
    const r = await startLoading(dispatch, 'saveTestDriveResultType', () => http.post('lookup/saveTestdriveResultType', state.testdriveResultType))
    return r.data
  },
  async getAdasExclusions({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getAdasExclusions', () => http.get('admin/getAdasExclusions'))
    commit(types.SET_ADAS_EXCLUSIONS, r.data)
    return r.data
  },
  async deleteAdasExclusion({ state, dispatch }, id) {
    const r = await startLoading(dispatch, 'deleteAdasExclusion', () => http.get(`admin/deleteAdasExclusion?id=${id}`))
    return r.data
  },
  async saveAdasExclusion({ state, dispatch }, exclusion) {
    const r = await startLoading(dispatch, 'saveAdasExclusion', () => http.post('admin/saveAdasExclusion', exclusion))
    return r.data
  },
  initAdasMatrix({ commit }) {
    commit(types.INIT_ADAS_MATRIX)
  },
  updateAdasMatrix({ commit }, data) {
    commit(types.UPDATE_ADAS_MATRIX, data)
  },
  updateAdasMatrixItem({ commit }, data) {
    commit(types.UPDATE_ADAS_MATRIXITEM, data)
  },
  getAdasMatrix({ commit }, id) {
    commit(types.SET_ADAS_MATRIX, id)
  },
  async getAdasMatrices({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getAdasMatrices', () =>
      http.get('admin/getAdasMatrix', {
        params: options
      })
    )
    commit(types.SET_ADAS_MATRICES, r.data)
    return r.data
  },
  async deleteAdasMatrix({ state, dispatch }, id) {
    const r = await startLoading(dispatch, 'deleteAdasMatrix', () => http.get(`admin/deleteAdasMatrix?id=${id}`))
    return r.data
  },
  async saveAdasMatrix({ state, dispatch }, item) {
    const r = await startLoading(dispatch, 'saveAdasMatrix', () => http.post('admin/saveAdasMatrix', item))
    return r.data
  },
  async decodeVin({ commit, dispatch }, vin) {
    const r = await startLoading(dispatch, 'decodeVin', () => http.get(`decode/adas?vin=${vin}`))
    commit(types.SET_DECODED_VIN, r.data)
    return r.data
  },
  async neoDecodeVin({ commit, dispatch }, vin) {
    const r = await startLoading(dispatch, 'altDecodeVin', () => http.get(`decode/adasneo?vin=${vin}`))
    commit(types.SET_DECODED_ALT_VIN, r.data)
    return r.data
  },
  async cdkDecodeVin({ commit, dispatch }, vin) {
    const r = await startLoading(dispatch, 'altDecodeVin', () => http.get(`decode/adascdk?vin=${vin}`))
    commit(types.SET_DECODED_ALT_VIN, r.data)
    return r.data
  },
  initMakeMatrix({ commit }) {
    commit(types.INIT_ADAS_MAKE_MATRIX)
  },
  updateAdasMakeMatrix({ commit }, data) {
    commit(types.UPDATE_ADAS_MAKE_MATRIX, data)
  },
  initAdasMatrixInfoLookup({ commit }) {
    commit(types.INIT_ADAS_MATRIX_INFO_LOOKUP)
  },
  updateAdasMatrixInfoLookup({ commit }, data) {
    commit(types.UPDATE_ADAS_MATRIX_INFO_LOOKUP, data)
  },
  async getAdasMakeMatrices({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getAdasMakeMatrices', () =>
      http.get('admin/getAdasMakeMatrices', {
        params: options
      })
    )
    commit(types.SET_ADAS_MAKE_MATRICES, r.data)
    return r.data
  },
  async getAdasMakeMatrix({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getAdasMakeMatrix', () => http.get(`admin/getAdasMakeMatrix?id=${id}`))
    commit(types.SET_ADAS_MAKE_MATRIX, r.data)
    return r.data
  },
  async deleteAdasMakeMatrix({ state, dispatch }, id) {
    const r = await startLoading(dispatch, 'deleteAdasMakeMatrix', () => http.get(`admin/deleteAdasMakeMatrix?id=${id}`))
    return r.data
  },
  async saveAdasMakeMatrix({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveAdasMakeMatrix', () => http.post('admin/saveAdasMakeMatrix', data))
    commit(types.SET_ADAS_MAKE_MATRIX_ID, r.data)
    return r.data
  },
  async saveAdasMakeMatrixLookups({ state, dispatch }, data) {
    let lookups = {
      adasChecklistMatrix: data.adasChecklistMatrix,
      adasChecklistMatrixVehicle: data.adasChecklistMatrixVehicle,
      systems: data.systems,
      locations: data.locations,
      static: data.static,
      dynamic: data.dynamic
    }
    const r = await startLoading(dispatch, 'saveAdasMakeMatrixLookups', () => http.post('admin/saveAdasMakeMatrixLookups', lookups))
    return r.data
  },
  async getAdasMatrixInfoLookups({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getAdasMatrixInfoLookups', () =>
      http.get('admin/getAdasMatrixInfoLookups', {
        params: options
      })
    )
    commit(types.SET_ADAS_MATRIX_INFO_LOOKUPS, r.data)
    return r.data
  },
  async getAdasMatrixInfoLookup({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getAdasMatrixInfoLookup', () => http.get(`admin/getAdasMatrixInfoLookup?id=${id}`))
    commit(types.SET_ADAS_MATRIX_INFO_LOOKUP, r.data)
    return r.data
  },
  async deleteAdasMatrixInfoLookup({ state, dispatch }, id) {
    const r = await startLoading(dispatch, 'deleteAdasMatrixInfoLookup', () => http.get(`admin/deleteAdasMatrixInfoLookup?id=${id}`))
    return r.data
  },
  async saveAdasMatrixInfoLookup({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveAdasMatrixInfoLookup', () => http.post('admin/saveAdasMatrixInfoLookup', data))
    commit(types.SET_ADAS_MATRIX_INFO_ID, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/actions.js